import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import MerchantPageShell from "../../components/merchant/MerchantPageShell";
import { verifyShopperEmail } from "../../lib/shopperAuthApi";
import { verifyMerchantEmail } from "../../lib/authApi";
import { useSession } from "../../hooks/useSession";
import { updateOnboarding } from "../../lib/onboardingApi";
import { clearShopperToken, clearVeyaTeamToken } from "../../lib/api";

export default function VerifyEmailPage({ accountType = "shopper" }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshSession } = useSession();

  const isMerchant = accountType === "merchant";

  const [status, setStatus] = useState("verifying");
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function verify() {
      const token = searchParams.get("token");

      if (!token) {
        setStatus("error");
        setError("Missing verification token.");
        return;
      }

      try {
        if (isMerchant) {
  clearShopperToken();
  clearVeyaTeamToken();

  await verifyMerchantEmail(token);
  await refreshSession();

        await updateOnboarding({
  current_step: "settings",
});

        if (!cancelled) {
  setStatus("success");
  setTimeout(() => {
    navigate("/merchant/settings", { replace: true });
  }, 1200);
}

        return;
        }

        await verifyShopperEmail(token);
        await refreshSession();

        if (!cancelled) {
          setStatus("success");
          setTimeout(() => {
            navigate("/account/avatar", { replace: true });
          }, 1200);
        }
      } catch (err) {
        console.error("Email verification failed", err);

        if (!cancelled) {
          setStatus("error");
          setError(err?.message || "Could not verify email.");
        }
      }
    }

    verify();

    return () => {
      cancelled = true;
    };
  }, [searchParams, isMerchant, navigate, refreshSession]);

  return (
    <MerchantPageShell
      eyebrow={isMerchant ? "Merchant Account" : "Shopper Account"}
      title={
        status === "success"
          ? "Email verified"
          : status === "error"
          ? "Verification failed"
          : "Verifying email"
      }
      lede={
        status === "success"
  ? isMerchant
    ? "Your account is verified. Redirecting you to settings so you can change your temporary password."
    : "Your account is ready."
          : status === "error"
          ? "This verification link could not be used."
          : "Please wait while we verify your account."
      }
    >
      <div className="merchant-form">
        {status === "verifying" ? (
          <p style={{ margin: 0, color: "rgba(43, 43, 43, 0.72)" }}>
            Verifying your email...
          </p>
        ) : null}

        {status === "success" ? (
          <p style={{ margin: 0, color: "rgba(43, 43, 43, 0.72)" }}>
            Redirecting you now...
          </p>
        ) : null}

        {status === "error" ? (
          <>
            <p className="merchant-error">{error}</p>

            <div className="merchant-actions">
              <Link
                className="gold-btn"
                to={isMerchant ? "/merchant/login" : "/login"}
                style={{ textDecoration: "none" }}
              >
                Go to login
              </Link>
            </div>
          </>
        ) : null}
      </div>
    </MerchantPageShell>
  );
}